// extracted by mini-css-extract-plugin
export default {"page":"Etudes_page__RM1Ae","container":"Etudes_container__QSXkm","header":"Etudes_header__rwcX7","bar":"Etudes_bar__P4-Lv","table":"Etudes_table__REe7B"};